import { createAsyncThunk } from '@reduxjs/toolkit';
import { AppDispatch } from 'app/store';
import { addNotification } from 'features/notification/notificationSlice';
import { getAktivRettighetEnheter } from 'services/bruker/brukerService';
import { EnhetDto } from 'services/enheter/dto';
import { SELECTED_ENHET_ID } from 'utils';
import { TraceableError } from 'utils/errors/customError';

import { setCurrentEnhetId } from '../auth/slice';
import { fetchRettigheter } from '../rettigheter/thunks';

export const fetchCurrentBrukerEnheter = createAsyncThunk<
  EnhetDto[],
  number,
  {
    dispatch: AppDispatch;
    rejectValue: string;
  }
>(
  'currentBruker/fetchCurrentBrukerEnheter',
  async (brukerId: number, { dispatch, rejectWithValue }) => {
    try {
      const enheter = (await getAktivRettighetEnheter(brukerId)).sort((a, b) =>
        a.navn.localeCompare(b.navn)
      );

      const storedEnhetId = Number(sessionStorage.getItem(SELECTED_ENHET_ID));

      let selectedEnhetId = 0;

      if (storedEnhetId > 0) {
        selectedEnhetId = storedEnhetId;
      } else if (enheter.length > 0) {
        selectedEnhetId = enheter[0]!.id;
      }

      dispatch(setCurrentEnhetId(selectedEnhetId));
      dispatch(fetchRettigheter({ enhetId: selectedEnhetId, brukerId }));

      return enheter;
    } catch (e) {
      const err = e as TraceableError;
      dispatch(
        addNotification({
          message: {
            text: 'En feil skjedde ved henting av enhetene brukeren har tilgang til',
          },
          variant: 'error',
        })
      );
      return rejectWithValue(err.message);
    }
  }
);
